export default {
  locationList:{},
  locationValuePairs:[],
  locationData: {},
  skillList:{},
  skillValuePairs:[],
  skillData: {},
  officeList:{},
  officeValuePairs:[],
  sapOfficeValuePairs:[],
  officeData: {},
  sectorList:{},
  sectorValuePairs:[],
  sectorData: {},
  meetingRoomCategoriesList:{},
  meetingRoomCategoryValuePairs:[],
  meetingRoomCategoriesValuePairs:[],
  meetingRoomCategoryData: {},
  meetingRoomList:{},
  meetingRoomValuePairs:[],
  meetingRoomData: {},
  availablemeetingroom: [],
  saltoLockValuePairs: [],
  meetingRoomsOfUsersLocation: [],
  totalNumberOfMembers: [],
  ticketCategoriesList:{},
  ticketCategoryValuePairs:[],
  ticketCategoryData: {},
  categoryAdminValuePairs: [], 
  sapOfficeList: [],
  eventCategoryList:{},
  eventCategoryValuePairs:[],
  eventCategoryData: {},
  eventList:{},
  eventValuePairs:[],
  eventData: {},
  eventCalendarList: {},
  eventListDatas: {},
  participantList: {},
  eventListDatasSimilar: {},  
  recursiveTicketCategoryValuePairs: [], 
  ticketCategoryAssignUserList:{},
  userValuePairs: [],
  koPerksCategoryValuePairs:[],
  koPerksData: {},
  koPerksListDatasSimilar: {},  



  // --------- Charts
  occupancyRate: [],
  numberOfMembers: [],

  userSegmentValuePairs:[],

  questionCategoryData: {},
  questionCategoryValuePairs:[],
  questionData: {},

  messageData: {},

};



// WEBPACK FOOTER //
// ./src/store/modules/definitions/state.js